export const state = {
    zkteco_user: {},
    createZktecoUser: false,  
    company_device_ids:[],
    location_ids:[],
};
